import type { TimeInterval } from 'typings'
import { create, each, enforce, omitWhen, test } from 'vest'
import { ValidationFn } from '../../../../providers'
import { messages } from './messages'

export function validation(
  name: string,
  enabled: boolean
): ValidationFn<TimeInterval[] | undefined> {
  return create((intervals: TimeInterval[], { intl: { formatMessage } }) => {
    omitWhen(!enabled, () => {
      each(intervals ?? [], (interval, index) => {
        test(`${name}.${index}.start`, formatMessage(messages.required), () => {
          enforce(interval.start).isNotUndefined()
        })

        test(`${name}.${index}.end`, formatMessage(messages.required), () => {
          enforce(interval.end).isNotUndefined()
        })

        omitWhen(!interval.start || !interval.end, () => {
          test(
            `${name}.${index}.start`,
            formatMessage(messages.valuesAreEqual),
            () => {
              enforce(interval.start?.getUTCHours()).notEquals(
                interval.end?.getUTCHours()
              )
            }
          )

          test(
            `${name}.${index}.end`,
            formatMessage(messages.valuesAreEqual),
            () => {
              enforce(interval.end?.getUTCHours()).notEquals(
                interval.start?.getUTCHours()
              )
            }
          )
        })
      })
    })
  })
}
